module.exports = __webpack_public_path__ + "static/inside-the-tornado-a08108870923b04c08f0dd8e3deffc34.jpg";